var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound"},[_vm._v("\n  404,您的页面路径有误！\n")])}
var staticRenderFns = []

export { render, staticRenderFns }